<template>
  <div class="container">
    <div class="privacy-content">
      <div v-if="type === 'loan'">
        <div class="section">
          <div class="section-title">1. 隐私政策</div>
          <div class="section-text">
            您的隐私对我们至关重要。本政策解释了我们会收集哪些信息，如何使用这些信息以及您对数据的控制权。请仔细阅读。
          </div>
          
          <div class="section-title">2. 我们收集的信息</div>
          <div class="section-subtitle">您直接提供的信息</div>
          <div class="section-text">
            账户注册：姓名、邮箱、手机号等。
            
            服务交互：订单记录、反馈内容、联系方式等。
          </div>
          
          <div class="section-subtitle">自动收集的信息</div>
          <div class="section-text">
            设备信息：设备型号、操作系统、唯一设备标识符（如IMEI）。
            
            使用数据：访问时间、功能使用频率、崩溃日志等。
            
            位置信息（仅限相关服务）：GPS或IP地址定位（需用户授权）。
          </div>
          
          <div class="section-subtitle">第三方来源的信息</div>
          <div class="section-text">
            通过社交媒体账号登录时，可能获取公开资料（如头像、昵称）。
          </div>
        </div>
        
        <div class="section">
          <div class="section-title">3. 我们如何使用信息</div>
          <div class="section-text">
            提供和优化服务（如账户管理、客服支持）。
            
            安全保障：检测异常活动，防止欺诈。
            
            统计分析：改进产品功能（匿名化处理数据）。
            
            营销推广（需用户单独同意）：发送促销信息。
          </div>
        </div>
        
        <div class="section">
          <div class="section-title">4. 数据共享与披露</div>
          <div class="section-text">
            我们仅在以下情况共享数据:
            
            第三方服务商：支付处理、云存储等（需签署保密协议）。
            
            法律要求：响应法院指令或政府调查。
            
            商业转让：如发生并购，用户数据可能转移。
          </div>
        </div>
        
        <div class="section">
          <div class="section-title">5. 数据存储与安全</div>
          <div class="section-text">
            存储期限：满足法律要求或业务所需的最短时间。
            
            安全措施：加密传输、访问控制、定期审计。
          </div>
        </div>
        
        <div class="section">
          <div class="section-title">6. 您的权利</div>
          <div class="section-text">
            访问、更正或删除您的个人信息。
            
            撤回同意（部分功能可能受限）。
            
            注销账户（通过设置或联系客服）。
          </div>
        </div>
        
        <div class="section">
          <div class="section-title">7. 儿童隐私</div>
          <div class="section-text">
            服务不面向13周岁（或所在国法定年龄）以下用户。如意外收集儿童数据，将立即删除。
          </div>
        </div>
        
        <div class="section">
          <div class="section-title">8. 政策更新</div>
          <div class="section-text">
            修改政策会通过App内公告或邮件通知。继续使用视为接受更新条款。
          </div>
        </div>
      </div>
      
      <div v-if="type === 'privacy'">
        <div class="section">
          <div class="section-title">隐私协议</div>
          <div class="section-text">
            本应用尊重并保护所有使用服务用户的个人隐私权。为了给您提供更准确、更有个性化的服务，本应用会按照本隐私权政策的规定使用和披露您的个人信息。但本应用将以高度的勤勉、审慎义务对待这些信息。除本隐私权政策另有规定外，在未征得您事先许可的情况下，本应用不会将这些信息对外披露或向第三方提供。本应用会不时更新本隐私权政策。 您在同意本应用服务使用协议之时，即视为您已经同意本隐私权政策全部内容。本隐私权政策属于本应用服务使用协议不可分割的一部分。
          </div>
          
          <div class="section-title">1. 适用范围</div>
          <div class="section-text">
            （a） 在您注册本应用帐号时，您根据本应用要求提供的个人注册信息；
            （b） 在您使用本应用网络服务，或访问本应用平台网页时，本应用自动接收并记录的您的浏览器和计算机上的信息，包括但不限于您的IP地址、浏览器的类型、使用的语言、访问日期和时间、软硬件特征信息及您需求的网页记录等数据；
            （c） 本应用通过合法途径从商业伙伴处取得的用户个人数据。
          </div>
          
          <div class="section-title">2. 信息使用</div>
          <div class="section-text">
            （a）本应用不会向任何无关第三方提供、出售、出租、分享或交易您的个人信息，除非事先得到您的许可，或该第三方和本应用（含本应用关联公司）单独或共同为您提供服务，且在该服务结束后，其将被禁止访问包括其以前能够访问的所有这些资料。
            （b） 本应用亦不允许任何第三方以任何手段收集、编辑、出售或者无偿传播您的个人信息。任何本应用平台用户如从事上述活动，一经发现，本应用有权立即终止与该用户的服务协议。
            （c） 为服务用户的目的，本应用可能通过使用您的个人信息，向您提供您感兴趣的信息，包括但不限于向您发出产品和服务信息，或者与本应用合作伙伴共享信息以便他们向您发送有关其产品和服务的信息（后者需要您的事先同意）。
          </div>
          
          <div class="section-title">3. 信息披露</div>
          <div class="section-text">
            在如下情况下，本应用将依据您的个人意愿或法律的规定全部或部分的披露您的个人信息：
            （a） 经您事先同意，向第三方披露；
            （b）为提供您所要求的产品和服务，而必须和第三方分享您的个人信息；
            （c） 根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；
            （d） 如您出现违反中国有关法律、法规或者本应用服务协议或相关规则的情况，需要向第三方披露；
            （e） 如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷；
            （f） 在本应用平台上创建的某一交易中，如交易任何一方履行或部分履行了交易义务并提出信息披露请求的，本应用有权决定向该用户提供其交易对方的联络方式等必要信息，以促成交易的完成或纠纷的解决。
          </div>
          
          <div class="section-title">4. 信息存储和交换</div>
          <div class="section-text">
            本应用收集的有关您的信息和资料将保存在本应用及（或）其关联公司的服务器上，这些信息和资料可能传送至您所在国家、地区或本应用收集信息和资料所在地的境外并在境外被访问、存储和展示。
          </div>
          
          <div class="section-title">5. Cookie的使用</div>
          <div class="section-text">
            （a） 在您未拒绝接受cookies的情况下，本应用会在您的计算机上设定或取用cookies ，以便您能登录或使用依赖于cookies的本应用平台服务或功能。本应用使用cookies可为您提供更加周到的个性化服务，包括推广服务。
            （b） 您有权选择接受或拒绝接受cookies。您可以通过修改浏览器设置的方式拒绝接受cookies。但如果您选择拒绝接受cookies，则您可能无法登录或使用依赖于cookies的本应用网络服务或功能。
            （c） 通过本应用所设cookies所取得的有关信息，将适用本政策。
          </div>
          
          <div class="section-title">6. 信息安全</div>
          <div class="section-text">
            （a） 本应用帐号均有安全保护功能，请妥善保管您的用户名及密码信息。本应用将通过对用户密码进行加密等安全措施确保您的信息不丢失，不被滥用和变造。尽管有前述安全措施，但同时也请您注意在信息网络上不存在"完善的安全措施"。
            （b） 在使用本应用网络服务进行网上交易时，您不可避免的要向交易对方或潜在的交易对方披露自己的个人信息，如联络方式或者邮政地址。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息泄密，尤其是本应用用户名及密码发生泄露，请您立即联络本应用客服，以便本应用采取相应措施。
          </div>
        </div>
      </div>
      
      <div v-if="type === 'customer'">
        <div class="section">
          <div class="section-title">客户须知</div>
          <div class="section-text">
            感谢您选择我们的贷款服务。请您在使用服务前仔细阅读以下重要内容：
          </div>
          
          <div class="section-title">1. 服务说明</div>
          <div class="section-text">
            我们提供便捷的小额贷款服务，帮助您解决临时资金需求。服务包括在线申请、快速审批、灵活还款等。
          </div>
          
          <div class="section-title">2. 利率与费用</div>
          <div class="section-text">
            年化利率：最低0.25%/月
            
            服务费：根据贷款金额收取，具体以合同为准
            
            逾期费用：逾期将按日收取逾期金额的0.05%作为违约金
          </div>
          
          <div class="section-title">3. 申请资格</div>
          <div class="section-text">
            年龄：22-55周岁
            
            身份：中国大陆公民
            
            信用：良好的个人信用记录
            
            收入：稳定的收入来源
          </div>
          
          <div class="section-title">4. 申请流程</div>
          <div class="section-text">
            注册账号 → 填写申请信息 → 提交审核 → 签署合同 → 放款到账
          </div>
          
          <div class="section-title">5. 还款方式</div>
          <div class="section-text">
            自动扣款：推荐使用，避免逾期
            
            主动还款：通过APP或合作平台还款
            
            还款日：请关注您的合同规定的还款日期
          </div>
          
          <div class="section-title">6. 逾期处理</div>
          <div class="section-text">
            1-3天逾期：短信提醒
            
            4-7天逾期：电话提醒
            
            7天以上逾期：可能影响个人信用记录，并采取法律手段追偿
          </div>
          
          <div class="section-title">7. 提前还款</div>
          <div class="section-text">
            允许提前还款，具体规则请查阅贷款合同。
          </div>
          
          <div class="section-title">8. 重要提示</div>
          <div class="section-text">
            请确保您理解并同意所有的条款和条件后再申请贷款。
            
            贷款有风险，借贷需谨慎。请根据自己的还款能力合理借款。
            
            如有任何疑问，请联系客服：400-123-4567
          </div>
        </div>
      </div>
    </div>
    
    <button class="back-btn" @click="goBack">返回</button>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPage',
  props: {
    type: {
      type: String,
      default: 'privacy'
    }
  },
  data() {
    return {
      someData: ''
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.container {
  padding: 20px;
  background-color: #ffffff;
  min-height: 100vh;
}

.privacy-content {
  max-height: calc(100vh - 100px);
  overflow-y: auto;
  background-color: #f9f9f9;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  font-size: 14px;
  line-height: 1.6;
  color: #333;
  white-space: pre-wrap;
}

.section {
  margin-bottom: 20px;
}

.section-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
}

.section-subtitle {
  font-size: 15px;
  font-weight: 500;
  color: #666;
  margin-bottom: 8px;
}

.section-text {
  font-size: 14px;
  color: #444;
  margin-bottom: 15px;
  line-height: 1.6;
}

.back-btn {
  width: 100%;
  height: 44px;
  line-height: 44px;
  text-align: center;
  background-color: #ff9800;
  color: #fff;
  border-radius: 22px;
  font-size: 16px;
  border: none;
  cursor: pointer;
}
</style>
